import commodityCatalogueService from '@billing/services/CommodityCatalogueService'
import { makeObservable, observable, runInAction } from 'mobx'
import {
  CommodityCatalogueDto,
  CreateCommodityCatalogueCommand,
  UpdateCommodityCatalogueCommand,
} from './../app/api'
import { BaseEntityStore } from './base/BaseEntityStore'

export class CatalogueStore extends BaseEntityStore<CommodityCatalogueDto> {
  selectedCatalogueId?: number = 0

  constructor() {
    super()
    makeObservable(this, {
      selectedCatalogueId: observable,
    })
  }

  public setSelectedCatalogueIdFromItems(shouldUpdate = false) {
    if (!this.selectedCatalogueId || shouldUpdate) {
      this.setSelectedCatalogueId(this.items[0]?.id ?? 0)
    }
  }

  public setSelectedCatalogueId(catalogueId?: number) {
    if (this.selectedCatalogueId !== catalogueId) {
      runInAction(() => {
        this.selectedCatalogueId = catalogueId
      })
    }
  }

  async load() {
    const catalogues = await commodityCatalogueService.getCatalogues()
    this.updateStoreItems(catalogues)
  }

  async createCatalogue(catalogue: CreateCommodityCatalogueCommand) {
    const id = await commodityCatalogueService.createCatalogue(catalogue)
    this.updateStoreItem({ ...catalogue, id }, id)

    this.setSelectedCatalogueIfUnset(id)
  }

  async updateCatalogue(id: number, catalogue: UpdateCommodityCatalogueCommand) {
    await commodityCatalogueService.updateCatalogue(catalogue)
    this.updateStoreItem({ ...catalogue, id }, id)

    this.setSelectedCatalogueIfUnset(id)
  }

  async deleteCatalogue(id: number) {
    await commodityCatalogueService.deleteCatalogue(id)
    this.deleteStoreItem(id)

    this.setSelectedCatalogueIdFromItems(this.selectedCatalogueId === id)
  }

  private setSelectedCatalogueIfUnset(catalogueId: number) {
    if (!this.selectedCatalogueId) {
      this.setSelectedCatalogueId(catalogueId)
    }
  }
}
